import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import {
  initGroupsPanel,
  addToGroupFolder,
} from '../../../AddToGroupsPanel/redux/actions';
import {
  getHasOnlyOneChunkOfGroupsToLoad,
  getHasNoGroups,
} from '../../../AddToGroupsPanel/redux/selectors';
import { Props } from './AddToGroupPopup';

export type StateProps = Pick<
  Props,
  'hasNoGroups' | 'hasOnlyOneChunkOfGroupsToLoad'
>;
export type DispatchProps = Pick<Props, 'initGroupsPanel' | 'addToGroupFolder'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  hasNoGroups: getHasNoGroups(state),
  hasOnlyOneChunkOfGroupsToLoad: getHasOnlyOneChunkOfGroupsToLoad(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  initGroupsPanel,
  addToGroupFolder,
};

export default connect(mapStateToProps, mapDispatchToProps);
